import React from 'react';
import CustomPopup from '../CustomPopup';
import { IPPParagraph } from '../../../library/Heading/Heading';

interface AlertPopupProps {
  show: boolean;
  onClose: () => void;
  message: string;
}

const AlertPopup: React.FC<AlertPopupProps> = ({ show, onClose, message }) => (
  <CustomPopup onClose={onClose} show={show} width="w-41%">
    <div className="max-h-30%">
      <IPPParagraph headerText={message} className="mr-0 mb-0.5 ml-0 text-[17px]" />
    </div>
  </CustomPopup>
);

export default React.memo(AlertPopup);
